<template>
  <div>
    <div class="px-5 sm:px-20 mt-10 pt-5" :class="{ '!p-0 !mt-0': isModal }">
      <div
        class="grid grid-cols-12 gap-4 gap-y-5 mt-5 items-baseline"
        data-test="health-form"
      >
        <div class="font-medium text-base col-span-12">
          ข้อมูลสุขภาพ
        </div>
        <div class="col-span-12">
          <label class="form-label">โรคประจำตัว (ตอบได้มากกว่า 1 ข้อ)</label>
        </div>
        <div
          class="col-span-12 sm:col-span-6"
          data-test="chronic-disease"
          v-for="(data, key) in data_chronic_disease"
          :key="key"
        >
          <div class="form-checkbox-custom pl-6 sm:flex">
            <div class="mr-3">
              <label class="form-check-label" :for="`form-input-health-${key}`">
                <input
                  :id="`form-input-health-${key}`"
                  class="form-check-input align-middle"
                  type="checkbox"
                  :value="data.option"
                  v-model="form.chronic_disease"
                />
                {{ data.option.desc }}
              </label>
            </div>
            <div
              class="form-input-for-checkbox"
              v-if="
                data.specify &&
                  form.chronic_disease.some(
                    ({ code }) => code == data.option.code,
                  )
              "
            >
              <input
                type="text"
                class="form-control"
                placeholder="กรุณาระบุ"
                :data-test="`form-input-health-other-${key}`"
                v-model="
                  form.chronic_disease[
                    form.chronic_disease.findIndex(
                      (p) => p.code == data.option.code,
                    )
                  ].disease_name
                "
                :class="{
                  'border-1 border-theme-24 rounded-md':
                    validate.chronic_disease.$each.$response.$errors[
                      form.chronic_disease.findIndex(
                        (p) => p.code == data.option.code,
                      )
                    ].disease_name.length,
                }"
              />
              <template
                v-if="
                  validate.chronic_disease.$each.$response.$errors[
                    form.chronic_disease.findIndex(
                      (p) => p.code == data.option.code,
                    )
                  ].disease_name.length
                "
              >
                <div
                  v-for="(error, index) in validate.chronic_disease.$each
                    .$response.$errors[
                    form.chronic_disease.findIndex(
                      (p) => p.code == data.option.code,
                    )
                  ].disease_name"
                  :key="index"
                  class="text-theme-24 mt-1 text-xs"
                >
                  {{ error.$message }}
                </div>
              </template>
            </div>
          </div>
        </div>
        <hr class="col-span-12" />
        <div class="font-medium text-base col-span-12">
          สิทธิการรักษาพยาบาล
        </div>
        <div class="col-span-12">
          <label class="form-label">สิทธิการรักษาพยาบาล</label>
          <RadioCustomButton
            class="w-40"
            name="med-radio-group"
            first-option-id="form-input-med-yes"
            second-option-id="form-input-med-no"
            :first-option-value="formOption.medSchemeOption[0].value"
            :second-option-value="formOption.medSchemeOption[1].value"
            :first-option-text="formOption.medSchemeOption[0].text"
            :second-option-text="formOption.medSchemeOption[1].text"
            v-model="validate.medScheme.$model"
            :class="{ 'border-theme-24': validate.medScheme.$error }"
          />
          <template v-if="validate.medScheme.$error">
            <div
              v-for="(error, index) in validate.medScheme.$errors"
              :key="index"
              class="text-theme-24 mt-1 text-xs"
            >
              {{ error.$message }}
            </div>
          </template>
        </div>
        <div class="col-span-12" v-if="form.medScheme == 'choose'">
          <div class="grid grid-cols-12 gap-4 gap-y-5">
            <div class="col-span-12">
              <label class="form-label"
                >ประเภทสิทธิการรักษาพยาบาล (ตอบได้มากกว่า 1 ข้อ)</label
              >
            </div>
            <div class="col-span-12">
              <div
                class="grid grid-cols-12 gap-4 gap-y-5"
                :class="{
                  'border-1 border-theme-24 rounded-md p-2':
                    validate.med_scheme.$error,
                }"
              >
                <div
                  class="col-span-12 sm:col-span-6"
                  v-for="(data, key) in data_med_scheme"
                  :key="key"
                >
                  <div class="form-checkbox-custom pl-6 ">
                    <div class="mr-3">
                      <label
                        class="form-check-label align-middle"
                        :for="`form-input-medscheme-${key}`"
                      >
                        <input
                          :id="`form-input-medscheme-${key}`"
                          class="form-check-input align-middle"
                          type="checkbox"
                          :value="data.option"
                          v-model="form.med_scheme"
                          @change="validate.med_scheme.$touch()"
                        />
                        {{ data.option.desc }}
                      </label>
                    </div>
                  </div>
                  <div
                    class="block md:flex mt-5 ml-6 flex-wrap"
                    v-if="
                      data.specify &&
                        form.med_scheme.some(
                          ({ code }) => code == data.option.code,
                        )
                    "
                  >
                    <label class="form-check-label ml-0 mr-2"
                      >ซึ่งเป็นสิทธิของ</label
                    >
                    <div class="block md:flex flex-wrap">
                      <div
                        class="form-check-input-indent mr-2 mt-2 sm:mt-0"
                        v-for="(choice, key2) in data.specify"
                        :key="key2"
                      >
                        <input
                          :id="`form-input-ofc-${key2}`"
                          class="form-check-input align-middle"
                          type="radio"
                          v-model="
                            form.med_scheme[
                              form.med_scheme.findIndex(
                                (p) => p.code == data.option.code,
                              )
                            ].ofc_owner
                          "
                          :value="choice.desc"
                        />
                        <label
                          class="form-check-label align-middle"
                          :for="`form-input-ofc-${key2}`"
                          >{{ choice.desc }}</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="validate.med_scheme.$error">
                <div class="text-theme-24 mt-1 text-xs">
                  {{ validate.med_scheme.required.$message }}
                </div>
              </template>
            </div>
          </div>
        </div>
        <hr class="col-span-12" />
        <div
          class="col-span-12 grid grid-cols-12 gap-4 gap-y-5"
        >
          <div class="col-span-12 flex items-center">
            <label class="font-medium text-base">
              ลักษณะความพิการ
            </label>
            <GenerateOtherSystemConnectionDEP
              v-if="form"
              :infoDataId="isModal ? editData._id : updateId"
              :infoData="editData"
              :national-id="depNationalId"
              :isModal="isModal"
              class="ml-2 mr-2 flex"
              @data-loaded="fillDisabilityForm"
              @dep-no-data="onDepNoData"
            />
          </div>
          <div
            v-show="!shouldHideDisabilitySection"
            class="col-span-12 grid grid-cols-12 gap-4 gap-y-5"
          >
            <div class="col-span-12 sm:col-span-6">
            <label class="form-label">ลักษณะความพิการ</label>
            <RadioCustomButton
              class="w-40"
              name="disabled-radio-group"
              first-option-id="form-input-disabled-yes"
              second-option-id="form-input-disabled-no"
              :first-option-value="formOption.isDisabledOption[0].value"
              :second-option-value="formOption.isDisabledOption[1].value"
              :first-option-text="formOption.isDisabledOption[0].text"
              :second-option-text="formOption.isDisabledOption[1].text"
              v-model="validate.is_disabled.$model"
              :class="{ 'border-theme-24': validate.is_disabled.$error }"
            />
            <template v-if="validate.is_disabled.$error">
              <div
                v-for="(error, index) in validate.is_disabled.$errors"
                :key="index"
                class="text-theme-24 mt-1 text-xs"
              >
                {{ error.$message }}
              </div>
            </template>
          </div>
          <div class="col-span-12 sm:col-span-6" v-if="form.is_disabled == 1">
            <label class="form-label">การมีบัตรประจำตัวคนพิการ</label>
            <RadioCustomButton
              class="w-60"
              name="pwd-card-radio-group"
              first-option-id="form-input-pwd-yes"
              second-option-id="form-input-pwd-no"
              third-option-id="form-input-pwd-expire"
              :first-option-value="formOption.pwdCardOption[0].value"
              :second-option-value="formOption.pwdCardOption[1].value"
              :third-option-value="formOption.pwdCardOption[2].value"
              :first-option-text="formOption.pwdCardOption[0].text"
              :second-option-text="formOption.pwdCardOption[1].text"
              :third-option-text="formOption.pwdCardOption[2].text"
              v-model="validate.have_pwd_card.$model"
              :class="{ 'border-theme-24': validate.have_pwd_card.$error }"
            />
            <template v-if="validate.have_pwd_card.$error">
              <div
                v-for="(error, index) in validate.have_pwd_card.$errors"
                :key="index"
                class="text-theme-24 mt-1 text-xs"
              >
                {{ error.$message }}
              </div>
            </template>
          </div>
          <div class="col-span-12" v-if="form.is_disabled == 1">
            <div class="grid grid-cols-12 gap-4 gap-y-5">
              <div class="col-span-12">
                <label class="form-label"
                  >ประเภทความพิการ (ตอบได้มากกว่า 1 ข้อ)</label
                >
              </div>
              <div class="col-span-12">
                <div
                  class="grid grid-cols-12 gap-4 gap-y-5"
                  :class="{
                    'border-1 border-theme-24 rounded-md p-2':
                      validate.disability.$error,
                  }"
                >
                  <div
                    class="col-span-12 sm:col-span-6"
                    v-for="(data, key) in data_disability"
                    :key="key"
                  >
                    <div class="form-checkbox-custom pl-6 ">
                      <div class="mr-3">
                        <label
                          class="form-check-label"
                          :for="`form-input-disability-${key}`"
                        >
                          <input
                            :id="`form-input-disability-${key}`"
                            class="form-check-input align-middle"
                            type="checkbox"
                            :value="data.option"
                            v-model="form.disability"
                            @change="validate.disability.$touch()"
                          />{{ data.option.desc }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <template v-if="validate.disability.$error">
                  <div
                    v-for="(error, index) in validate.disability.$errors"
                    :key="index"
                    class="text-theme-24 mt-1 text-xs"
                  >
                    {{ error.$message }}
                  </div>
                </template>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div
          class="col-span-12"
          v-if="
            form.is_disabled == 1 &&
              (hasDepLinking(form.linking_system) || form.dep)
          "
        >
          <div class="grid grid-cols-12 gap-4 gap-y-5">
            <div class="col-span-12 flex items-center">
              <label class="form-label">ข้อมูลจากระบบทะเบียนคนพิการ</label>
              <!-- <GenerateOtherSystemConnectionDEP
                v-show="shouldHideDisabilitySection"
                v-if="form"
                :infoDataId="isModal ? editData._id : updateId"
                :infoData="editData"
                :national-id="depNationalId"
                :isModal="isModal"
                class="ml-2 mr-2 flex"
                @data-loaded="fillDisabilityForm"
              /> -->
            </div>
            <div class="accordion accordion-boxed col-span-12">
              <div class="accordion-item">
                <div v-show="shouldHideDisabilitySection">
                  <div
                    class="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-4 py-2"
                  >
                    <div class="flex flex-wrap items-center gap-2">
                      <span class="text-theme-37 shrink-0"
                        >ลักษณะความพิการ</span
                      >
                      <div
                        class="px-3 py-1.5 border border-theme-39 text-theme-37 rounded-md inline-block"
                      >
                        {{
                          `${
                            is_disabled?.valueOf() != undefined
                              ? is_disabled
                                ? "พิการ"
                                : "ไม่พิการ"
                              : ""
                          }`
                        }}
                      </div>
                    </div>
                    <div class="flex flex-wrap items-center gap-2">
                      <span class="text-theme-37 shrink-0"
                        >มีบัตรประจำตัวคนพิการ</span
                      >
                      <div
                        class="px-3 py-1.5 border border-theme-39 text-theme-37 rounded-md inline-block"
                      >
                        <div v-if="have_pwd_card == 1">
                          มีบัตร
                        </div>
                        <div v-else-if="have_pwd_card == 2">
                          บัตรหมดอายุ
                        </div>
                        <div v-else>
                          ไม่มีบัตร
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-wrap items-center gap-2 py-2">
                    <span class="text-theme-37 shrink-0">ประเภทความพิการ</span>
                    <div
                      class="px-3 py-1.5 border border-theme-39 text-theme-37 rounded-md inline-block min-w-0 max-w-full"
                    >
                      <div v-for="(data, key) in disability" :key="key">
                        {{ data.desc }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- แถวที่ 1: สถานะบุคคล | วันที่อนุมัติขึ้นทะเบียน -->
                <div
                  class="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-4 py-2"
                >
                  <div class="flex flex-wrap items-center gap-2">
                    <span class="text-theme-37 shrink-0">สถานะบุคคล</span>
                    <div
                      class="px-3 py-1.5 border border-theme-39 text-theme-37 rounded-md inline-block"
                    >
                      {{ dep_person_subtype }}
                    </div>
                  </div>
                  <div class="flex flex-wrap items-center gap-2">
                    <span class="text-theme-37 shrink-0"
                      >วันที่อนุมัติขึ้นทะเบียน</span
                    >
                    <div
                      class="px-3 py-1.5 border border-theme-39 text-theme-37 rounded-md inline-block"
                    >
                      {{ dep_permit_date }}
                    </div>
                  </div>
                </div>
                <!-- แถวที่ 2: วันที่ออกบัตร | วันที่บัตรหมดอายุ -->
                <div
                  class="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-4 py-2"
                >
                  <div class="flex flex-wrap items-center gap-2">
                    <span class="text-theme-37 shrink-0">วันที่ออกบัตร</span>
                    <div
                      class="px-3 py-1.5 border border-theme-39 text-theme-37 rounded-md inline-block"
                    >
                      {{ dep_card_issue_date }}
                    </div>
                  </div>
                  <div class="flex flex-wrap items-center gap-2">
                    <span class="text-theme-37 shrink-0"
                      >วันที่บัตรหมดอายุ</span
                    >
                    <div
                      class="px-3 py-1.5 border border-theme-39 text-theme-37 rounded-md inline-block"
                    >
                      {{ dep_card_expire_date }}
                    </div>
                  </div>
                </div>
                <!-- แถวที่ 3: ผู้ดูแลคนพิการ เต็มความกว้าง -->
                <div class="flex flex-wrap items-center gap-2 py-2">
                  <span class="text-theme-37 shrink-0">ผู้ดูแลคนพิการ</span>
                  <div
                    class="px-3 py-1.5 border border-theme-39 text-theme-37 rounded-md inline-block min-w-0 max-w-full"
                  >
                    {{ dep_person }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <hr class="col-span-12" /> -->
        <template v-if="shouldHideDisabilitySection">
          <div class="col-span-12">
            ข้อมูลสำรวจเพิ่มเติม
          </div>
          <div class="col-span-12">
            <label class="form-label"
              >ประเภทความพิการ (ตอบได้มากกว่า 1 ข้อ)</label
            >
          </div>
          <div
            class="col-span-12 sm:col-span-6"
            v-for="(data, key) in data_disability"
            :key="key"
          >
            <div class="form-checkbox-custom pl-6 sm:flex">
              <div class="mr-3">
                <label
                  class="form-check-label"
                  :for="`form-input-mso-disability-${key}`"
                  :class="{ 'text-theme-37': isInFormDisability(data.option) }"
                >
                  <input
                    :id="`form-input-mso-disability-${key}`"
                    class="form-check-input align-middle"
                    type="checkbox"
                    :checked="
                      isInFormDisability(data.option) ||
                      isInMsoSurveyDisability(data.option)
                    "
                    :disabled="isInFormDisability(data.option)"
                    @change="
                      toggleMsoSurveyDisability(
                        data.option,
                        $event.target.checked
                      )
                    "
                  />
                  {{ data.option.desc }}
                  <span
                    v-if="isInFormDisability(data.option)"
                    class="t-tooltip inline-flex justify-center items-center ml-1 w-4 h-4 align-middle"
                  >
                    <span class="t-tooltip-text text-xs">
                      รายการนี้ไม่สามารถแก้ไขได้ เป็นข้อมูลที่มาจากระบบทะเบียนคนพิการ
                    </span>
                    <InfoIcon
                      class="w-4 h-4 !stroke-2"
                    />
                  </span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-span-12">
            <label class="form-label"
              >ประสงค์มีบัตรประจำตัวคนพิการ</label
            >
            <RadioCustomButton
              class="w-60"
              name="need-pwd-card-radio-group"
              first-option-id="form-input-need-pwd-yes"
              second-option-id="form-input-need-pwd-no"
              :first-option-value="formOption.npwdCardOption[0].value"
              :second-option-value="formOption.npwdCardOption[1].value"
              :first-option-text="formOption.npwdCardOption[0].text"
              :second-option-text="formOption.npwdCardOption[1].text"
              v-model="form.mso_survey.need_pwd_card"
            />
          </div>
        </template>
      </div>
      <hr class="col-span-12 mt-10" />
    </div>
    <div class="col-span-12 flex items-center mt-10 justify-end" v-if="isModal">
      <div>
        <button
          class="btn btn-outline-secondary"
          data-dismiss="modal"
          @click="cancelModalButton"
        >
          ยกเลิก
        </button>
        <button class="btn btn-primary ml-2" @click="nextStep">
          บันทึก
        </button>
      </div>
    </div>
    <div
      class="col-span-12 flex items-center mt-10 px-5 sm:px-20 justify-between"
      v-else
    >
      <div>
        <button class="btn btn-secondary" @click="closeWizardForm">
          ออก
        </button>
        <button class="btn btn-secondary ml-2" @click="skipStep">
          ข้าม
        </button>
      </div>
      <div>
        <button class="btn btn-secondary ml-2" @click="prevStep">
          ย้อนกลับ
        </button>
        <button class="btn btn-primary ml-2" @click="nextStep">
          บันทึกและถัดไป
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, defineComponent, ref, toRefs, watch, computed } from "vue";
import dataJson from "@/data/health.json";
import RadioCustomButton from "@/components/base/radio-custom-button/index.vue";
import useVuelidate from "@vuelidate/core";
import { required, helpers, requiredIf } from "@vuelidate/validators";
import Swal from "sweetalert2";
import axios from "axios";
import GenerateOtherSystemConnectionDEP from "@/views/member/container/DEP.vue";
// import GenerateOtherSystemConnectionDEP from "@/views/member/container/GenerateOtherSystemConnectionDEP.vue";
import { useStore } from "vuex";
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary m-1",
    cancelButton: "btn btn-outline-secondary m-1",
  },
  buttonsStyling: false,
});
export default defineComponent({
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    updateId: {
      type: String,
    },
    nationalId: {
      type: String,
      default: "",
    },
    editData: {
      type: Object,
    },
    cancelModal: {
      type: Boolean,
      default: false,
    },
    openModal: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RadioCustomButton,
    GenerateOtherSystemConnectionDEP,
  },
  setup(props, { emit }) {
    const depNationalId = computed(() =>
      props.isModal
        ? props.editData?.national_id ?? props.editData?.idCardNumber ?? ""
        : props.nationalId ?? "",
    );
    const dep_person = ref("");
    const dep_card_expire_date = ref("");
    const dep_card_issue_date = ref("");
    const dep_permit_date = ref("");
    const dep_person_subtype = ref("");
    const mapSubtypeToThai = (code) => {
      const mapping = {
        Current: "คนพิการจดทะเบียน",
        Out: "เสียชีวิต",
        Normal: "หายจากความพิการ",
        Well: "ยังไม่เข้าเกณฑ์คนพิการ",
        Cancel: "ยกเลิก",
        NoCard: "ไม่ประสงค์มีบัตรประจำตัวคนพิการ",
        IsNot: "ไม่ได้เป็นคนพิการ",
        Wait: "อยู่ระหว่างการอนุมัติจากนายทะเบียน...",
        Expire: "บัตรหมดอายุ",
        Caution: "บุคคลที่อาจไม่เข้าเกณฑ์ความพิการ",
        NoRequest: "ไม่มีแบบคำขอมีบัตร",
        IncFLName: "ชื่อ-นามสกุลไม่ตรงกับกรมการปกครอง",
        Again: "แบบคำขอไม่อนุมัติ จนท.ต้องบันทึกคำขอใหม่",
        NoComplete: "ข้อมูลไม่สมบูรณ์",
        InIDP: "อยู่ในสถานสงเคราะห์ฯ ของ พก.",
        InCentral: "อยู่ในทะเบียนบ้านกลาง",
      };

      if (!code || code === "-") {
        return "-";
      }

      return mapping[code] || code;
    };
    const depNoData = ref(false);
    const depHasDataFromApi = ref(false);
    const DEP_Disability = reactive({
      is_disabled: 0,
    });
    const formOption = reactive({
      medSchemeOption: [
        { text: "มีสิทธิ", value: "choose" },
        { text: "ไม่มีสิทธิ", value: "MS7" },
      ],
      isDisabledOption: [
        { text: "พิการ", value: 1 },
        { text: "ไม่พิการ", value: 0 },
      ],
      pwdCardOption: [
        { text: "มีบัตร", value: 1 },
        { text: "ไม่มีบัตร", value: 0 },
        { text: "บัตรหมดอายุ", value: 2 },
      ],
      npwdCardOption: [
        { text: "ประสงค์", value: 1 },
        { text: "ไม่ประสงค์", value: 0 },
      ],
      medSchema: [],
    });
    const form = reactive({
      chronic_disease: [],
      med_scheme: [],
      disability: [],
      mso_survey: { disability: [], need_pwd_card: null },
      have_pwd_card: null,
      is_disabled: null,
      medScheme: null,
      linking_system: [],
    });
    const formDefault = reactive({
      chronic_disease: [],
      med_scheme: [],
      disability: [],
      mso_survey: { disability: [], need_pwd_card: null },
      have_pwd_card: null,
      is_disabled: null,
      medScheme: null,
      linking_system: [],
    });
    const data_chronic_disease = reactive(dataJson.health.chronic_disease);
    const data_med_scheme = reactive(dataJson.health.med_scheme);
    const data_disability = reactive(dataJson.health.disability);
    const rules = {
      med_scheme: {
        required: helpers.withMessage(
          `กรุณาเลือกสิทธิการรักษาพยาบาล`,
          requiredIf(() => form.medScheme == "choose"),
        ),
        $each: helpers.forEach({
          ofc_owner: {
            required: helpers.withMessage(`กรุณาระบุ`, required),
          },
        }),
      },
      disability: {
        required: helpers.withMessage(
          `กรุณาเลือกความพิการ`,
          requiredIf(() => form.is_disabled == 1),
        ),
      },
      have_pwd_card: {
        required: helpers.withMessage(
          `กรุณาเลือก`,
          requiredIf(() => form.is_disabled == 1),
        ),
      },
      is_disabled: {
        required: helpers.withMessage(`กรุณาเลือก`, required),
      },
      medScheme: {
        required: helpers.withMessage(`กรุณาเลือก`, required),
      },
      chronic_disease: {
        $each: helpers.forEach({
          disease_name: {
            required: helpers.withMessage(`กรุณาระบุ`, required),
          },
        }),
      },
    };
    const currStep = ref(3);
    const validate = useVuelidate(rules, toRefs(form));
    const store = useStore();
    const token = store.getters["userAuth/getToken"];
    function nextStep() {
      validate.value.$touch();
      if (validate.value.$invalid) {
        return;
      }
      let _update = {
        is_disabled:
          form.is_disabled?.valueOf() != undefined ? form.is_disabled : null,
        have_pwd_card:
          form.have_pwd_card?.valueOf() != undefined
            ? form.have_pwd_card
            : null,
        chronic_disease:
          form.chronic_disease?.length > 0 ? form.chronic_disease : null,
        med_scheme: form.med_scheme?.length > 0 ? form.med_scheme : null,
        disability: form.disability?.length > 0 ? form.disability : null,
        mso_survey: {
          disability:
            form.mso_survey?.disability?.length > 0
              ? form.mso_survey.disability
              : null,
          need_pwd_card:
            form.mso_survey?.need_pwd_card != null
              ? form.mso_survey.need_pwd_card
              : null,
        },
      };
      let dep_data = null;
      console.log(DEP_Disability);
      if (form.is_disabled === 1 && !props.isModal) {
        dep_data = {
          dep: {
            maimad_age: form.dep?.maimad_age,
            curator_prefix_name: form.dep?.curator_prefix_name,
            curator_first_name: form.dep?.curator_first_name,
            curator_last_name: form.dep?.curator_last_name,
            curator_person_code: form.dep?.curator_person_code,
            curator_relation_code: form.dep?.curator_relation_code,
            curator_relation_name: form.dep?.curator_relation_name,
            curator_relation_other: form.dep?.curator_relation_other,
            card_issue_date: form.dep?.card_issue_date,
            card_expire_date: form.dep?.card_expire_date,
            permit_date: form.dep?.permit_date,
            person_subtype: form.dep?.person_subtype,
          },
          linking_system: form.linking_system,
        };
        _update = { ..._update, ...dep_data };
      }
      if (_update.is_disabled != 1) {
        _update.dep = null;
      }
      const config = {
        url: `${process.env.VUE_APP_BASE_API}member/${
          props.isModal ? props.editData._id : props.updateId
        }`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": `application/json; charset=utf-8`,
        },
        data: {
          update: _update,
        },
      };
      if (props.isModal) {
        swalCustom
          .fire({
            text: "ยืนยันบันทึกข้อมูล",
            icon: "info",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: "ตกลง",
            cancelButtonText: "ยกเลิก",
          })
          .then((result) => {
            if (result.isConfirmed) {
              axios(config)
                .then(() => {
                  swalCustom
                    .fire({
                      text: "สำเร็จ",
                      icon: "success",
                      timer: 3000,
                      confirmButtonText: "ปิด",
                    })
                    .then(() => {
                      cash("#edit-member-modal").modal("hide");
                      emit("update-state");
                    });
                })
                .catch((error) => {
                  swalCustom.fire({
                    text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                    icon: "warning",
                    //timer: 3000, //timeOut for auto-close
                    confirmButtonText: "ปิด",
                  });
                  console.log(error);
                });
            }
          });
      } else {
        axios(config)
          .then(() => {
            emit("next-step", currStep.value);
          })
          .catch((error) => {
            swalCustom.fire({
              text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
              icon: "warning",
              //timer: 3000, //timeOut for auto-close
              confirmButtonText: "ปิด",
            });
            console.log(error);
          });
      }
    }
    function skipStep() {
      emit("skip-step", currStep.value);
    }
    function closeWizardForm() {
      emit("close-wizard", currStep.value);
    }
    function prevStep() {
      emit("prev-step", currStep.value);
    }
    watch(
      () => props.cancelModal,
      (val) => {
        if (val) {
          Object.assign(form, formDefault);
          validate.value.$reset();
        }
      },
    );
    function normalizeLinkingSystem(arr) {
      if (!Array.isArray(arr)) return [];
      return arr.map((item) =>
        typeof item === "object" && item != null && "system" in item
          ? item
          : {
              system: String(item),
              updated_at: new Date().toISOString().split("T")[0],
            },
      );
    }
    function hasDepLinking(linkingSystem) {
      if (!Array.isArray(linkingSystem)) return false;
      return linkingSystem.some(
        (item) =>
          (typeof item === "object" && item?.system === "DEP") ||
          item === "DEP",
      );
    }
    function onDepNoData() {
      depNoData.value = true;
      depHasDataFromApi.value = false;
    }
    function hasAnyDepData(dep) {
      if (!dep || typeof dep !== "object") return false;
      const keys = [
        "maimad_age",
        "curator_prefix_name",
        "curator_first_name",
        "curator_last_name",
        "curator_person_code",
        "curator_relation_code",
        "curator_relation_name",
        "curator_relation_other",
        "card_issue_date",
        "card_expire_date",
        "permit_date",
        "person_subtype",
      ];
      return keys.some((k) => dep[k] != null && String(dep[k]).trim() !== "");
    }
    function isInFormDisability(option) {
      return (form.disability || []).some((x) => x?.code === option?.code);
    }
    function isInMsoSurveyDisability(option) {
      return (form.mso_survey?.disability || []).some(
        (x) => x?.code === option?.code,
      );
    }
    function toggleMsoSurveyDisability(option, checked) {
      if (!form.mso_survey)
        form.mso_survey = { disability: [], need_pwd_card: null };
      if (!Array.isArray(form.mso_survey.disability))
        form.mso_survey.disability = [];
      const idx = form.mso_survey.disability.findIndex(
        (x) => x?.code === option?.code,
      );
      if (checked) {
        if (idx === -1) {
          form.mso_survey.disability.push({
            code: option.code,
            desc: option.desc,
          });
        }
      } else {
        if (idx !== -1) form.mso_survey.disability.splice(idx, 1);
      }
    }
    const is_disabled = computed(() => {
      return form.is_disabled?.valueOf() != undefined ? form.is_disabled : null;
    });
    const have_pwd_card = computed(() => {
      return form.have_pwd_card?.valueOf() != undefined
        ? form.have_pwd_card
        : null;
    });
    const disability = computed(() => {
      let result = [];
      if (form.disability?.length > 0) {
        result = [...form.disability];
      }
      return result;
    });
    // ซ่อนเมื่อ: มี DEP ใน linking และ is_disabled เป็น 1 และ (พบข้อมูลจาก DEP API หรือมีข้อมูลใน form.dep)
    const shouldHideDisabilitySection = computed(() => {
      const hasDepData =
        depHasDataFromApi.value ||
        hasAnyDepData(form?.dep) ||
        hasAnyDepData(props.editData?.dep);
      // console.log("ddddd");
      // console.log(hasDepData);
      // console.log(depHasDataFromApi.value);
      // console.log(hasAnyDepData(form.dep));
      // console.log(form.dep);
      // console.log(form.linking_system);
      // console.log(hasDepLinking(form.linking_system));
      // console.log(form.is_disabled);
      return (
        form?.is_disabled === 1 &&
        hasDepData
      );
    });
    watch(
      () => props.openModal,
      (val) => {
        if (val) {
          depNoData.value = false;
          depHasDataFromApi.value = false;
          const dataEdit = JSON.parse(JSON.stringify(props.editData));
          form.med_scheme =
            dataEdit.med_scheme?.length > 0 ? dataEdit.med_scheme : [];
          form.is_disabled =
            dataEdit.is_disabled?.valueOf() != undefined
              ? dataEdit.is_disabled
              : null;
          form.have_pwd_card =
            dataEdit.have_pwd_card?.valueOf() != undefined
              ? dataEdit.have_pwd_card
              : null;
          form.chronic_disease =
            dataEdit.chronic_disease?.length > 0
              ? dataEdit.chronic_disease
              : [];
          form.disability =
            dataEdit.disability?.length > 0 ? dataEdit.disability : [];
          form.mso_survey = {
            disability:
              dataEdit.mso_survey?.disability?.length > 0
                ? [...dataEdit.mso_survey.disability]
                : [],
            need_pwd_card:
              dataEdit.mso_survey?.need_pwd_card != null
                ? dataEdit.mso_survey.need_pwd_card
                : null,
          };
          form.linking_system =
            normalizeLinkingSystem(dataEdit.linking_system) || [];

          dep_card_expire_date.value = dataEdit.dep?.card_expire_date || "-";
          dep_card_issue_date.value = dataEdit.dep?.card_issue_date || "-";
          dep_permit_date.value = dataEdit.dep?.permit_date || "-";
          dep_person_subtype.value = mapSubtypeToThai(
            dataEdit.dep?.person_subtype || "-",
          );
          if (
            !dataEdit.dep?.curator_first_name &&
            !dataEdit.dep?.curator_last_name
          ) {
            dep_person.value = "-";
          } else {
            const prefix = dataEdit.dep?.curator_prefix_name || "";
            const first = dataEdit.dep?.curator_first_name || "";
            const last = dataEdit.dep?.curator_last_name || "";

            let relation = "";
            if (dataEdit.dep?.curator_relation_code === "07") {
              relation =
                dataEdit.dep?.curator_relation_other || "ไม่ระบุความสัมพันธ์";
            } else {
              relation =
                dataEdit.dep?.curator_relation_name || "ไม่ระบุความสัมพันธ์";
            }

            const fullName = [prefix + first, last].filter(Boolean).join(" ");
            dep_person.value = `${fullName} (${relation})`.trim();
          }

          if (form.med_scheme?.length > 0) {
            form.med_scheme.forEach((item) => {
              if (item.code != "MS7") {
                form.medScheme = "choose";
                let idx_data = data_med_scheme.findIndex(
                  (x) => x.option.code == item.code,
                );
                data_med_scheme[idx_data].option = item;
              } else {
                form.medScheme = "MS7";
              }
            });
          }
          if (form.chronic_disease?.length > 0) {
            form.chronic_disease.forEach((item) => {
              let idx_data = data_chronic_disease.findIndex(
                (x) => x.option.code == item.code,
              );
              data_chronic_disease[idx_data].option = item;
            });
          }
          if (form.disability?.length > 0) {
            form.disability.forEach((item) => {
              let idx_data = data_disability.findIndex(
                (x) => x.option.code == item.code,
              );
              data_disability[idx_data].option = item;
            });
          }
        }
      },
    );
    watch(
      () => form.medScheme,
      (val) => {
        if (val == "MS7") {
          form.med_scheme = reactive([]);
          form.med_scheme.push({
            code: "MS7",
            desc: "ไม่มีสิทธิ์",
          });
        } else {
          let idx_data = form.med_scheme.findIndex((x) => x.code == "MS7");
          if (idx_data != -1) {
            form.med_scheme.splice(idx_data, 1);
          }
        }
      },
      { deep: true },
    );
    watch(
      () => form.is_disabled,
      (val) => {
        if (val == 0) {
          form.have_pwd_card = null;
          form.disability = [];
        }
      },
    );
    function cancelModalButton() {
      validate.value.$reset();
      emit("cancelButton");
    }
    function fillDisabilityForm(depData) {
      if (depData) {
        depNoData.value = false;
        depHasDataFromApi.value = true;
        if (depData.is_disabled !== undefined) {
          form.is_disabled = depData.is_disabled;
        }
        if (depData.have_pwd_card !== undefined) {
          form.have_pwd_card = depData.have_pwd_card;
        }
        if (depData.disability && Array.isArray(depData.disability)) {
          form.disability = depData.disability;
          form.disability.forEach((item) => {
            let idx_data = data_disability.findIndex(
              (x) => x.option.code == item.code,
            );
            if (idx_data !== -1) {
              data_disability[idx_data].option = item;
            }
          });
        }
        dep_card_expire_date.value = depData.dep?.card_expire_date || "-";
        dep_card_issue_date.value = depData.dep?.card_issue_date || "-";
        dep_permit_date.value = depData.dep?.permit_date || "-";
        dep_person_subtype.value = mapSubtypeToThai(
          depData.dep?.person_subtype || "-",
        );
        form.dep = {};
        form.dep.maimad_age = depData.dep?.maimad_age;
        form.dep.curator_prefix_name = depData.dep?.curator_prefix_name;
        form.dep.curator_first_name = depData.dep?.curator_first_name;
        form.dep.curator_last_name = depData.dep?.curator_last_name;
        form.dep.curator_person_code = depData.dep?.curator_person_code;
        form.dep.curator_relation_code = depData.dep?.curator_relation_code;
        form.dep.curator_relation_name = depData.dep?.curator_relation_name;
        form.dep.curator_relation_other = depData.dep?.curator_relation_other;
        form.dep.card_issue_date = depData.dep?.card_issue_date;
        form.dep.card_expire_date = depData.dep?.card_expire_date;
        form.dep.permit_date = depData.dep?.permit_date;
        form.dep.person_subtype = depData.dep?.person_subtype;

        if (!form.dep?.curator_first_name && !form.dep?.curator_last_name) {
          dep_person.value = "-";
        } else {
          const prefix = form.dep.curator_prefix_name || "";
          const first = form.dep.curator_first_name || "";
          const last = form.dep.curator_last_name || "";

          let relation = "";
          if (form.dep.curator_relation_code === "07") {
            relation =
              form.dep.curator_relation_other || "ไม่ระบุความสัมพันธ์";
          } else {
            relation =
              form.dep.curator_relation_name || "ไม่ระบุความสัมพันธ์";
          }

          const fullName = [prefix + first, last].filter(Boolean).join(" ");
          dep_person.value = `${fullName} (${relation})`.trim();
        }
        validate.value.is_disabled.$touch();
        validate.value.have_pwd_card.$touch();
        validate.value.disability.$touch();
        console.log("ข้อมูลความพิการจาก DEP ถูกเติมลงในฟอร์มแล้ว");
        if (!props.openModal) {
          form.linking_system = [
            {
              system: "DEP",
              updated_at: new Date().toISOString().split("T")[0],
            },
          ];
        }
        // else{
        //   if(dataEdit.linking_system){
        //     if(!dataEdit.linking_system.includes("DEP")){
        //       form.linking_system = dataEdit.linking_system.push("DEP")
        //     }
        //   }else{
        //    form.linking_system = ["DEP"]
        //   }
        // }
      }
    }
    // watch(
    //   () => form.med_scheme,
    //   () => {
    //     let checked_lst = [...form.med_scheme]
    //     //set data to default when uncheck
    //     data_med_scheme.forEach((item)=>{
    //       if(!checked_lst.includes(item)){
    //         item.amount = null
    //       }
    //     })
    //   },
    //   {deep: true}
    // )

    return {
      form,
      depNationalId,
      DEP_Disability,
      formOption,
      nextStep,
      skipStep,
      closeWizardForm,
      prevStep,
      validate,
      data_chronic_disease,
      data_disability,
      data_med_scheme,
      cancelModalButton,
      fillDisabilityForm,
      dep_person,
      dep_card_expire_date,
      dep_card_issue_date,
      dep_permit_date,
      dep_person_subtype,
      hasDepLinking,
      shouldHideDisabilitySection,
      onDepNoData,
      isInFormDisability,
      isInMsoSurveyDisability,
      toggleMsoSurveyDisability,
      is_disabled,
      disability,
      have_pwd_card,
    };
  },
});
</script>

<style lang="scss"></style>
